var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1333 25.4002L27.5333 16.0002L25.6667 14.1335L18.1333 21.6668L14.3333 17.8668L12.4667 19.7335L18.1333 25.4002ZM10.6667 32.0002C9.93333 32.0002 9.30556 31.739 8.78333 31.2168C8.26111 30.6946 8 30.0668 8 29.3335V10.6668C8 9.9335 8.26111 9.30572 8.78333 8.7835C9.30556 8.26127 9.93333 8.00016 10.6667 8.00016H16.2667C16.5556 7.20016 17.0389 6.55572 17.7167 6.06683C18.3944 5.57794 19.1556 5.3335 20 5.3335C20.8444 5.3335 21.6056 5.57794 22.2833 6.06683C22.9611 6.55572 23.4444 7.20016 23.7333 8.00016H29.3333C30.0667 8.00016 30.6944 8.26127 31.2167 8.7835C31.7389 9.30572 32 9.9335 32 10.6668V29.3335C32 30.0668 31.7389 30.6946 31.2167 31.2168C30.6944 31.739 30.0667 32.0002 29.3333 32.0002H10.6667ZM10.6667 29.3335H29.3333V10.6668H10.6667V29.3335ZM20 9.66683C20.2889 9.66683 20.5278 9.57238 20.7167 9.3835C20.9056 9.19461 21 8.95572 21 8.66683C21 8.37794 20.9056 8.13905 20.7167 7.95016C20.5278 7.76127 20.2889 7.66683 20 7.66683C19.7111 7.66683 19.4722 7.76127 19.2833 7.95016C19.0944 8.13905 19 8.37794 19 8.66683C19 8.95572 19.0944 9.19461 19.2833 9.3835C19.4722 9.57238 19.7111 9.66683 20 9.66683Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveVerification);
export default __webpack_public_path__ + "static/media/ActiveVerification.5f4a84aa3700046b055638fade957769.svg";
export { ForwardRef as ReactComponent };